/* eslint-disable no-self-assign */
import React, { useState } from 'react'
import styled from 'styled-components'
import { H3, Span, Text } from '../ui/Typography'
import { Flex } from '../ui/Layout'
import Button from '../ui/Button'
import ResponsiveModal from '../ui/ResponsiveModal'
import ToggleRedGreen from '../ui/ToggleRedGreen'
import plans from '../Plans'
import Icon from '../ui/Icon'
import { openChat } from './ChatButton'
import { useAuth } from '../Auth'
import api from '../api.js'
import PricingCards from './PricingCards'
import Image from '../ui/Image'

// Styled components
const DarkSection = styled(Flex)`
  background: #000;
  width: 40%;
  padding-top: 42px;
  padding-bottom: 42px;
  color: white;
  flex-direction: column;
  justify-content: space-between;
`

const ContentSection = styled(Flex)`
  width: 60%;
  min-width: 1000px;
  padding: 32px;
  flex-direction: column;
`

const ResponsiveImage = styled(Image)`
  @media (min-width: 1600px) {
    width: 60%;
  }
`

const PaywallModal = ({ show, setShow }) => {
  let { user, setUser } = useAuth()
  const [isAnnual, setIsAnnual] = useState(true)
  const plansToShow = [5, 6, 7]
  const [showSpinner, setShowSpinner] = useState(false)

  // THIS SHIT IS NOW DUPLICATE
  // THIS SHIT IS NOW DUPLICATE
  // See: ../Components/PaywallModal.js
  const addPlan = async (planId) => {
    setShowSpinner(true)
    if (user.shopifyShopUrl) {
      return addShopifyPlan(planId)
    } else {
      return addStripePlan(planId)
    }
  }

  const addShopifyPlan = async (planId) => {
    const res = await api.post('/shopify/create-subscription', {
      planId,
      redirectUrl: window.location.href,
      isAnnual: isAnnual
    })
    if (res.data.payload.isFree) {
      window.location.href = window.location.href
    }
    const redirectUrl = res.data.payload.redirectUrl
    if (redirectUrl) {
      window.location.href = redirectUrl
    }
  }

  const addStripePlan = async (planId) => {
    const res = await api.post('/stripe/create-subscription', {
      planId,
      redirectUrl: window.location.href,
      tolt: window.tolt_referral,
      isAnnual: isAnnual
    })
    if (res.data.payload.isFree) {
      window.location.href = window.location.href
    }
    const redirectUrl = res.data.payload.redirectUrl
    if (redirectUrl) {
      window.location.href = redirectUrl
    }
  }
  // THIS SHIT IS NOW DUPLICATE
  // THIS SHIT IS NOW DUPLICATE

  return (
    <ResponsiveModal isOpen={show} setIsOpen={setShow}>
      <Flex height="100%">
        <DarkSection>
          <Text fontSize="32px" fontWeight="800" lineHeight="100%" color="white" px="32px">
            100s of beautiful, fast video embed layouts and customisations
          </Text>
          <ResponsiveImage src="/illustrations/paywallPeople.png" alt="Paywall people Image" width="70%" />
          <Flex justifyContent="flex-end">
            <ResponsiveImage src="/illustrations/paywallCountries.png" alt="Paywall countries Image" width="70%" />
          </Flex>
          <Text fontSize="18px" color="white" fontWeight="500" px="32px">
            Featured on 1,000s of creative websites
          </Text>
        </DarkSection>

        <ContentSection>
          <Flex flexDirection="column" mb={24}>
            <Text fontSize="28px" fontWeight="600" lineHeight="136%" mb="8px">
              Upgrade to embed on your website
            </Text>
            <Text fontSize="16px" lineHeight="162%" light>
              Upgrade for embedding, fast streaming, increased storage and streaming, 100s of designs, interactive video and more
            </Text>
          </Flex>

          <PricingCards
            plansToShow={plansToShow}
            isAnnual={isAnnual}
            setIsAnnual={setIsAnnual}
            addPlan={addPlan}
            showSpinner={showSpinner}
          />
        </ContentSection>
      </Flex>
    </ResponsiveModal>
  )
}

export default PaywallModal
